import { makeStyles } from '@mui/styles'
import idsTheme, { defaultPalette } from '../../../../theme/idsTheme'

const theme = idsTheme()

export default makeStyles(() => ({
    ContactFormProvider: {
        display: 'flex',
        rowGap: '2.125rem',
        flexDirection: 'column',
    },
    ContactFormBody: {
        display: 'flex',
        flexDirection: 'column',
        gap: '2.5rem',
    },
    ContactFormContainer: {
        maxWidth: 'unset',
        padding: '1.5rem',
        background: '#ffffff',
        borderRadius: '16px',
        overflow: 'hidden',
        boxShadow: '0px 1px 18px rgba(221,225,236,0.6)',
        [theme.breakpoints.up('sm')]: {
            padding: '3.5rem',
        },
    },
    ContactHeaderSubTitle: {
        color: defaultPalette.typography.light,
    },
    ContactFormAutoCreationChip: {
        color: defaultPalette.primary.main,
        backgroundColor: '#E9FAFB',
        fontSize: '16px',
    },
    ContactFormAutoCreationChipIcon: {
        color: `${defaultPalette.primary.main} !important`,
    },
}))
